import { render, staticRenderFns } from "./DashboardStatisticsDetailsPage.vue?vue&type=template&id=0200c541&scoped=true&"
import script from "./DashboardStatisticsDetailsPage.vue?vue&type=script&lang=js&"
export * from "./DashboardStatisticsDetailsPage.vue?vue&type=script&lang=js&"
import style0 from "./DashboardStatisticsDetailsPage.vue?vue&type=style&index=0&id=0200c541&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0200c541",
  null
  
)

export default component.exports